import React, { useMemo } from 'react'

import { LntSelect } from '@app/components/base'
import { TopFilters as TopFiltersWrapper } from '@app/components'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { LOCATION_KEY } from '@app/constants/queryKeys'
import { SIZE } from '@app/constants'

import { getClusters } from '@app/api/routes/locationСlusters'
import { getSalesOrganization } from '@app/api/routes/locationSalesOrganization'
import { getClusterGroups } from '@app/api/routes/locationClusterGroups'
import { getCompetitorsNetworks } from '@app/api/routes/locationCompetitorsNetworks'
import { getCompetitors } from '@app/api/routes/locationCompetitors'

import { useFiltersSearch } from '@app/hooks'

import { getFilterCompetitorsFormEntities, getFilterFromEntities } from '@app/utils/entitiesAdapters'

import type { TopFilterProps } from './types'
import type { LntSelectProps } from '@app/components/base/Select/types'

const commonSelectProps: LntSelectProps<number[]> = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle,
  strictValue: true
}

export const TopFilters: React.FC<TopFilterProps> = ({ onSearch, initialFilters }) => {
  const { filters, canResetFilters, handleClearFilters, handleSearch, handleSelectFilterChange } = useFiltersSearch({
    initialFilters,
    onSearch
  })

  const competitorsParams = useMemo(() => ({ networkIds: filters.competitorIds }), [filters])

  return (
    <TopFiltersWrapper
      canReset={ canResetFilters }
      onClear={ handleClearFilters }
      onSearch={ handleSearch }
    >
      <LntSelect
        { ...commonSelectProps }
        value={ filters.salesOrganizationIds }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.salesOrganizationIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.salesOrganizationFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationSalesOrganizationsItems],
          queryFn: getSalesOrganization,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.clustersGroupIds }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.clustersGroupIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.clusterGroupsFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClusterGroupsItems],
          queryFn: getClusterGroups,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.clusterIds }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.clusterIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.clustersFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClustersItems],
          queryFn: getClusters,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.competitorIds }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.competitorIds, value) }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationCompetitorsItems],
          queryFn: getCompetitorsNetworks,
          select: getFilterFromEntities
        } }
        placeholder={ FILTERS_PLACEHOLDERS.competitorsNetworksFilter }
      />

      <LntSelect
        { ...commonSelectProps }
        disabled={ !filters.competitorIds?.length }
        value={ filters.competitorNetworkIds }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.competitorNetworkIds, value) }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationCompetitorsNetworksItems, competitorsParams],
          queryFn: async () => await getCompetitors(competitorsParams),
          select: getFilterCompetitorsFormEntities
        } }
        placeholder={ FILTERS_PLACEHOLDERS.competitorsAddressesFilter }
      />
    </TopFiltersWrapper>
  )
}
